import { use } from 'react';
import { ApplicantSessionContext, type ApplicantSessionState } from './ApplicantSessionContext';

export function useApplicantSession(): ApplicantSessionState {
  const state = use(ApplicantSessionContext);
  if (!state) {
    throw new Error('useApplicantSession must be used inside ApplicantSessionProvider.');
  }
  return state;
}
